<template>
  <div>
  </div>
</template>

<script>
import md5 from 'js-md5';
import {nanoid} from 'nanoid'
import {singleHomeServer} from "@/common/api-config";

export default {
  data() {
    return {
      logo: "",
    }
  },
  created() {
    this.queryAppInfo()
  },
  methods: {
    queryAppInfo() {
      singleHomeServer.device().then(res => {
        if (res["code"] == 0) {
          this.statistics(res.data)
        } else {
          this.$router.push({
            path: '/error201',
          })
        }
      }).catch(err => {
        this.addOpenExceptLog()
      })
    },
    // 错误处理
    handleError() {
      // 如果设置了兜底页，跳转兜底页
      if (this.$cookies.get('apkUrl')) {
        window.location.href = this.$cookies.get('apkUrl')
      } else {
        this.$router.push({
          path: '/error201',
        })
      }
    },

    //统计PU,UV
    statistics(data) {
      return new Promise((resolve) => {
        /* 参数msd加密用作签名*/
        let now = Date.now();//时间戳
        if (this.$cookies.get('cuid') == '') {
          let expiresTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
          this.$cookies.set('cuid', nanoid(), expiresTime);
        }
        let dataArray = {
          cuid: this.$cookies.get('cuid'),
          app_id: this.$cookies.get('appId'),
          app_link_id: this.$cookies.get('appLinkId'),
          target: data.deviceBrand,
          device_brand: data.deviceBrand,
          device_model: data.deviceModel,
        }
        let device = JSON.stringify(dataArray)
        let paramStr = decodeURIComponent('device=' + device + "&timestamp=" + now)
        let sign = md5('Fw0sDp6fl1jt5FtpBJFyLQy1rRSIVIxDZCWPYM5IIMQu6CSn' + md5(paramStr));//MD5加密

        singleHomeServer.addEventLog({
          device: device,
          timestamp: now,
          sign: sign,//	必填	string	签名
        }).then((res) => {
          if (data.deviceBrand == 'vivo') {
            window.location.href = this.$cookies.get('vivoUrl')
          } else if (data.deviceBrand == 'xiaomi') {
            window.location.href = this.$cookies.get('xiaomiUrl')
          } else if (this.$cookies.get('apkUrl')) {
            window.location.href = this.$cookies.get('apkUrl')
          } else {
            this.$router.push({
              path: '/error201',
            })
          }
        }).catch(() => {
          this.$router.push({
            path: '/error201',
          })
        });
      });
    },
    // 异常事件日志
    addOpenExceptLog() {
      return new Promise((resolve) => {
        /* 参数msd加密用作签名*/
        let now = Date.now();//时间戳
        if (this.$cookies.get('cuid') == '') {
          let expiresTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
          this.$cookies.set('cuid', nanoid(), expiresTime);
        }
        let dataArray = {
          cuid: this.$cookies.get('cuid') || '',
          app_id: this.$cookies.get('appId') || '',
          app_link_id: this.$cookies.get('appLinkId') || '',
        }
        let device = JSON.stringify(dataArray)
        let paramStr = decodeURIComponent('device=' + device + "&timestamp=" + now)
        let sign = md5('Fw0sDp6fl1jt5FtpBJFyLQy1rRSIVIxDZCWPYM5IIMQu6CSn' + md5(paramStr));//MD5加密

        singleHomeServer.addOpenExceptLog({
          device: device,
          timestamp: now,
          sign: sign,//	必填	string	签名
        }).then(() => {
          this.handleError()
        }).catch(() => {
          this.handleError()
        });
      });
    }
  }

}
</script>

<style>

</style>
